import React, { Component } from 'react';

import { DynamicFieldsAPI } from '@philips-emr/tws-components-api';
import { DynamicFieldsType } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, element, eventListener, object, oneOfType } from '@philips-emr/tws-core/lib/component/prop-types';
import { getLostProps, isFunction, propagateData } from '@philips-emr/tws-utils';

import { NotFound } from '..';

import { getComponents, jsonConditionLogicEval, jsonLogicEval } from './dynamic-fields-utils';

@AwesomeComponent({ type: ComponentType.FORM, api: DynamicFieldsAPI })
class DynamicFields extends Component {

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    data: object.notEnumerable(),
    metaData: object.notEnumerable(),
    onBlur: eventListener,
    onChange: eventListener,
    onFocus: eventListener,
    record: object.notEnumerable(),
  };

  formulas = [];
  visualData = {};

  addFormula = (entry, formula) => {
    this.formulas.push({ exp: formula, entry: entry });
  }

  addVisualData = (entry, label) => {
    this.visualData = { ...this.visualData, [entry]: label };
  }

  renderComponents() {
    const { data, metaData } = this.props;

    if (!(metaData && metaData.children && metaData.componentType === DynamicFieldsType.DYNAMIC_FIELDS)) {
      return <NotFound />;
    }

    return metaData.children.map(child => getComponents(child, this.addFormula, this.addVisualData, this.onBlur, this.onFocus, this.resolveConditions(child, data)));
  }

  onFieldChange = ({ entry, value, oldValue }) => {
    const { onChange } = this.props;

    this.formulaEval(entry, value, oldValue);

    isFunction(onChange) && onChange({ entry, value, oldValue });
  };

  formulaEval(entry, value) {
    const { data, onChange } = this.props;

    this.formulas.forEach(formula => {
      const result = jsonLogicEval(formula.exp, { ...data, [entry]: value });

      if (result && isFunction(onChange)) {
        onChange({ entry: formula.entry, value: `${result}`, oldValue: data[formula.entry] });
      }
    });
  }

  clearGlobals() {
    this.formulas = [];
    this.visualData = {};
  }

  internalGetLostProps() {
    const inheritedProps = getLostProps(DynamicFields.propTypes, this.props);

    return {
      ...inheritedProps,
      onChange: this.onFieldChange,
    };
  }

  resolveConditions(child, data) {
    if (!data) {
      return;
    }

    if (!child.visibilityCondition) {
      return;
    }

    return jsonConditionLogicEval(child.visibilityCondition, data);
  }

  render() {
    const { data } = this.props;

    this.clearGlobals();
    const lostProps = this.internalGetLostProps();
    const components = this.renderComponents();

    return propagateData(components, { ...data, ...this.visualData }, lostProps);
  }
}

export default DynamicFields;
